import React, { useEffect, useRef, useState } from "react";
import {
	Box,
	Typography,
	TextField,
	Button,
	Divider,
	Grid,
	Checkbox,
	FormControlLabel,
	IconButton,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import FlightInfo from "../FlightInfo/FlightInfo";
import { BasicModal } from "../BasicModal/BasicModal";
import { Delete, DeleteForever } from "@mui/icons-material";
import Close from "@mui/icons-material/Close";
import GoogleMaps1 from "../../assets/google-maps/google-maps-1.png";
import GoogleMaps2 from "../../assets/google-maps/google-maps-2.png";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import { useWindowSize } from "@uidotdev/usehooks";
import { loadGoogleMaps } from "../../utils/loadGoogleMaps";

const defaultData = [
	{
		departureAirport: "",
		departureDay: "",
		departureTime: "",
		duration: "",
		arrivalDay: "",
		arrivalTime: "",
		arrivalAirport: "",
		hasStopover: false,
		stopoverDuration: "",
	},
];

const Map = ({ page, updatePage, index, height }) => {
	const [iframe, setIframe] = useState(page.maps[index]);
	const [savedIframe, setSavedIframe] = useState(null);
	const [errorIframe, setErrorIframe] = useState(false);
	//const [src, setSrc] = useState(null);
	const size = useWindowSize();
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalText, setModalText] = useState("");
	const [showMapInfo, setShowMapInfo] = useState(false);

	const handleModalSave = () => {
		try {
			setSavedIframe(iframe);
			const newMaps = [...(page.maps || ["", "", ""])];
			newMaps[index] = iframe;
			updatePage({ ...page, maps: newMaps });

			setIsModalOpen(false);
		} catch (error) {
			console.error(error);
		}
	};

	const handleModalCancel = () => {
		setIsModalOpen(false);
	};

	const initMap2 = (mapURL) => {
		const mapEl = document.getElementById("map - " + page.id + " - " + index);
		if (!mapEl || !window.google || !window.google.maps) return;

		class LabelOverlay extends window.google.maps.OverlayView {
			constructor(position, text, map) {
				super();
				this.position = position;
				this.text = text;
				this.map = map;
				this.div = null;
				this.setMap(map);
			}

			onAdd() {
				const div = document.createElement("div");
				div.style.position = "absolute";
				div.style.background = "white";
				div.style.border = "1px solid black";
				div.style.padding = "2px";
				div.style.fontSize = "14px";
				div.innerHTML = this.text;
				this.div = div;

				const panes = this.getPanes();
				panes.overlayLayer.appendChild(div);
			}

			draw() {
				const overlayProjection = this.getProjection();
				const position = overlayProjection.fromLatLngToDivPixel(this.position);

				const div = this.div;
				div.style.left = position.x + "px";
				div.style.top = position.y + "px";
			}

			onRemove() {
				if (this.div) {
					this.div.parentNode.removeChild(this.div);
					this.div = null;
				}
			}
		}

		// Get the current URL
		const url = new URL(mapURL);
		const pathname = url.pathname;
		const searchParams = new URLSearchParams(url.search);

		let mapOptions = {
			zoom: 15,
			center: { lat: 0, lng: 0 },
		};

		let map = new window.google.maps.Map(mapEl, mapOptions);

		if (pathname.startsWith("/maps/@")) {
			// Just the map view
			const [lat, lng, zoom] = pathname
				.split("/@")[1]
				.split("?")[0]
				.split("/")[0]
				.replaceAll("z", "")
				.split(",")
				.map(Number);
			map.setCenter({ lat, lng });
			map.setZoom(zoom);
		} else if (pathname.startsWith("/maps/dir/")) {
			// Directions
			const [lat, lng, zoom] = pathname
				.split("/@")[1]
				.split("?")[0]
				.split("/")[0]
				.replaceAll("z", "")
				.split(",")
				.map(Number);
			map.setCenter({ lat, lng });
			map.setZoom(zoom);
			const waypoints = pathname.split("/dir/")[1].split("/");
			const start = waypoints[0];
			const end = waypoints[waypoints.length - 3];
			const intermediatePoints = waypoints.slice(1, -3);
			const travelModeMatch = pathname.match(/!3e(\d)/);
			let mode = "DRIVING";
			if (travelModeMatch && travelModeMatch[1]) {
				switch (parseInt(travelModeMatch[1], 10)) {
					case 0:
						mode = window.google.maps.TravelMode.DRIVING;
						break;
					case 1:
						mode = window.google.maps.TravelMode.BICYCLING;
						break;
					case 2:
						mode = window.google.maps.TravelMode.WALKING;
						break;
					case 3:
						mode = window.google.maps.TravelMode.TRANSIT;
						break;
					default:
						mode = window.google.maps.TravelMode.DRIVING;
				}
			}

			const directionsService = new window.google.maps.DirectionsService();
			const directionsRenderer = new window.google.maps.DirectionsRenderer({
				suppressMarkers: true,
			});
			directionsRenderer.setMap(map);

			const request = {
				origin: decodeURIComponent(start),
				destination: decodeURIComponent(end),
				waypoints: intermediatePoints.map((point) => ({
					location: decodeURIComponent(point),
					stopover: true,
				})),
				travelMode: window.google.maps.TravelMode[mode],
			};

			directionsService.route(request, (result, status) => {
				if (status === "OK") {
					directionsRenderer.setDirections(result);
					const service = new window.google.maps.places.PlacesService(map);
					result.geocoded_waypoints.forEach((place) => {
						service.getDetails(
							{
								placeId: place.place_id,
							},
							(place) => {
								if (place) {
									new window.google.maps.Marker({
										map,
										position: place.geometry.location,
									});

									new LabelOverlay(place.geometry.location, place.name, map);
								}
							},
						);
					});
				}
			});
		} else if (pathname.startsWith("/maps/search/")) {
			// Search
			const query = pathname.split("/search/")[1];
			const [lat, lng, zoom] = pathname
				.split("/@")[1]
				.split("?")[0]
				.split("/")[0]
				.replaceAll("z", "")
				.split(",")
				.map(Number);
			map.setCenter({ lat, lng });
			map.setZoom(zoom);

			const service = new window.google.maps.places.PlacesService(map);
			service.textSearch(
				{ location: { lat, lng }, radius: 500, query: query.split("/")[0] },
				(results, status) => {
					if (status === window.google.maps.places.PlacesServiceStatus.OK) {
						results.forEach((place) => {
							new window.google.maps.Marker({
								map,
								position: place.geometry.location,
							});

							new LabelOverlay(place.geometry.location, place.name, map);
						});
					}
				},
			);
		} else if (pathname.startsWith("/maps/place/")) {
			const query = pathname.split("/maps/place/")[1];
			const [lat, lng, zoom] = pathname
				.split("/@")[1]
				.split("?")[0]
				.split("/")[0]
				.replaceAll("z", "")
				.split(",")
				.map(Number);
			map.setCenter({ lat, lng });
			map.setZoom(zoom);

			const service = new window.google.maps.Geocoder();
			service.geocode(
				{
					address: decodeURIComponent(query.split("/")[0]),
					location: {
						lat: lat,
						lng: lng,
					},
				},
				(results, status) => {
					if (status === "OK") {
						results.forEach((place) => {
							new window.google.maps.Marker({
								map,
								position: place.geometry.location,
							});

							new LabelOverlay(
								place.geometry.location,
								decodeURIComponent(query.split("/")[0]).replaceAll("+", " "),
								map,
							);
						});
					}
				},
			);
		} else {
			console.error("Unsupported URL format");
		}
	};

	const checkMaps = () => {
		let newMaps = [];
		for (const map of page.maps) {
			newMaps.push(null);
			if (map) {
				try {
					initMap2(map);
				} catch (error) {
					console.error(error);
				}
			}
		}
	};

	useEffect(() => {
		let cancelled = false;
		loadGoogleMaps()
			.then(() => {
				if (!cancelled) checkMaps();
			})
			.catch((error) => {
				console.error(error);
			});
		return () => {
			cancelled = true;
		};
	}, []);

	useEffect(() => {
		if (savedIframe && page.maps[index] === savedIframe) {
			setSavedIframe(null);
			loadGoogleMaps()
				.then(() => {
					checkMaps();
				})
				.catch((error) => {
					console.error(error);
				});
		}
	}, [page, savedIframe]);

	return (
		<>
			{!page.maps[index] ? (
				<Box
					className="template-item"
					data-template-item
					data-map-placeholder="true"
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						width: "100%",
						height: height || "100%",
						border: "2px dashed rgba(99, 102, 241, 0.4)",
						backgroundColor: "rgba(248, 250, 252, 0.8)",
						transition: "all 0.2s ease",
						position: "relative",
						zIndex: 1001,
						pointerEvents: "auto",
						"&:hover": {
							borderColor: "rgba(99, 102, 241, 0.7)",
							backgroundColor: "rgba(99, 102, 241, 0.05)",
						},
					}}
				>
					<Button
						className="template-item"
						data-template-item
						variant="contained"
						onClick={() => {
							setIsModalOpen(true);
						}}
						sx={{
							background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
							textTransform: "none",
							fontWeight: 600,
							borderRadius: 2,
							padding: "6px 12px",
							boxShadow: "0 4px 16px rgba(99, 102, 241, 0.35)",
							"&:hover": {
								background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
								boxShadow: "0 6px 20px rgba(99, 102, 241, 0.45)",
								transform: "translateY(-2px)",
							},
							fontSize: "0.75rem",
							position: "relative",
							zIndex: 1001,
							pointerEvents: "auto",
						}}
					>
						Añadir mapa
					</Button>
				</Box>
			) : (
				<Box
					sx={{
						overflow: "hidden",
						height: "100%", // "calc(0+ 200px)",
						position: "relative",
					}}
				>
					{
						/*mapDetails && mapDetails.length > index && mapDetails[index] &&*/ true && (
							<Box
								sx={{
									width: "100%",
									height: "100%",
									"& .gmnoprint": { display: "none" },
								}}
							>
								<div
									id={"map - " + page.id + " - " + index}
									style={{ width: "100%", height: "100%" }}
								/>
								{/*<GoogleMap
							mapContainerStyle={{
								width: "100%",
								height: "100%",
							}}
							center={{
								lat: parseFloat(
									page.maps[index]
										.split("!2d")[1]
										.split("!3d")[1]
										.split("!2m")[0]
								),
								lng: parseFloat(
									page.maps[index].split("!2d")[1].split("!3d")[0]
								),
							}}
							zoom={10}
						></GoogleMap>*/}
							</Box>
						)
					}
					{/*<iframe
						src={page.maps[index].replaceAll("&#39;", "'")}
						//src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d35571.0267690527!2d2.116823969663173!3d41.38653434901742!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e2!4m5!1s0x12a4a2f3c37acd4f%3A0xc6878e918e86b13e!2sPla%C3%A7a%20Catalunya%2C%20Barcelona!3m2!1d41.38736!2d2.1696958!4m5!1s0x12a498f576297baf%3A0x44f65330fe1b04b9!2sSpotify%20Camp%20Nou%2C%20C%2F%20d&#39;Ar%C3%ADstides%20Maillol%2C%2012%2C%2008028%20Barcelona!3m2!1d41.380896!2d2.1228198!5e0!3m2!1ses!2ses!4v1701543266618!5m2!1ses!2ses"
						width="100%"
						height="100%"
						style={{
							border: 0,
							marginTop: "-140px",
							height: "calc(0+ 250px)",
						}}
						allowfullscreen=""
						loading="lazy"
						referrerpolicy="no-referrer-when-downgrade"
					></iframe>*/}

					<IconButton
						className="template-item"
						data-template-item
						aria-label="edit map"
						sx={{
							position: "absolute",
							top: 0,
							right: 0,
							cursor: "pointer",
							backgroundColor: "white",
							marginTop: 2,
							marginRight: 2,
							zIndex: 1001,
							pointerEvents: "auto",
							"&:hover": {
								backgroundColor: "rgba(248, 250, 252, 0.9)",
							},
						}}
						onClick={() => {
							setIsModalOpen(true);
						}}
					>
						<ModeEditIcon />
					</IconButton>
				</Box>
			)}
			<BasicModal
				width={isSmallScreen ? "100%" : 600}
				showModal={isModalOpen}
				handleClose={handleModalCancel}
				children={
					<Box sx={{ padding: { xs: 2, sm: 3 } }}>
						<Box sx={{ mb: { xs: 3, sm: 4 } }}>
							<Typography
								variant="h5"
								sx={{
									fontWeight: 700,
									color: "#1e293b",
									mb: 1,
									fontSize: { xs: "1.25rem", sm: "1.5rem" },
								}}
							>
								Añade el mapa
							</Typography>
							<Typography
								variant="body2"
								sx={{
									color: "text.secondary",
									fontSize: { xs: "0.875rem", sm: "0.95rem" },
								}}
							>
								Utiliza Google Maps para mostrar el mapa en la página.
							</Typography>
						</Box>
						<Box
							sx={{
								display: "flex",
								backgroundColor: "#f1f2f6",
								padding: { xs: 1.5, sm: 2 },
								marginTop: 2,
								marginBottom: 2,
								position: "relative",
								flexDirection: "column",
								borderRadius: 1,
							}}
						>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
								onClick={() => {
									!showMapInfo && setShowMapInfo(true);
								}}
							>
								<Typography
									variant="body2"
									sx={{
										fontWeight: 700,
										fontSize: { xs: "0.875rem", sm: "1rem" },
										"&:hover": {
											textDecoration: "underline",
											cursor: "pointer",
										},
									}}
								>
									¿Cómo añadir el mapa?
								</Typography>
								{showMapInfo && (
									<IconButton
										aria-label="add"
										sx={{ position: "absolute", top: 0, right: 0 }}
										onClick={() => {
											setShowMapInfo(false);
										}}
									>
										<Close />
									</IconButton>
								)}
							</Box>
							{showMapInfo && (
								<Box sx={{ marginTop: 2 }}>
									<Typography
										variant="body2"
										sx={{
											fontSize: { xs: "0.8125rem", sm: "0.875rem" },
										}}
									>
										1. Ve a{" "}
										<a href="https://www.google.es/maps" target="_blank">
											https://www.google.es/maps{" "}
										</a>
										<br />
										<br />
										2. Añade sitios en el mapa, crea una ruta, busca punto de
										interés en un área o sencillamente encuadra la región que
										quieras compartir.
										<img
											alt="google-maps"
											src={GoogleMaps1}
											style={{ width: "100%", marginTop: "12px" }}
										/>
										<br />
										<br />
										3. Copía la dirección de la página web desde la barra de
										navegación de tu navegador o aprieta en compartir la
										dirección desde las opciones del navegador y copia la
										dirección.
										<img
											alt="google-maps"
											src={GoogleMaps2}
											style={{ width: "100%", marginTop: "12px" }}
										/>
										<br />
										<br />
										4. Inserta la dirección copiada en el campo abajo de estas
										instrucciones.
									</Typography>
								</Box>
							)}
						</Box>
						<Typography
							sx={{
								textTransform: "uppercase",
								fontSize: { xs: "0.625rem", sm: "0.75rem" },
								marginTop: 2,
								fontWeight: 600,
							}}
						>
							Mapa
						</Typography>
						<TextField
							InputLabelProps={{ shrink: false }}
							fullWidth
							label=""
							id="url-google-maps"
							placeholder="URL de Google Maps"
							value={iframe}
							sx={{ fontWeight: 300 }}
							error={errorIframe}
							onPaste={(e) => {
								try {
									setIframe(e.clipboardData.getData("text"));
									setErrorIframe(false);
									const url = new URL(e.clipboardData.getData("text"));
									const pathname = url.pathname;

									if (
										!(
											pathname.startsWith("/maps/@") ||
											pathname.startsWith("/maps/dir/") ||
											pathname.startsWith("/maps/search/") ||
											pathname.startsWith("/maps/place/")
										)
									) {
										throw Error("Invalid URL");
									}
								} catch (error) {
									console.error(error);
									// SHOW ERROR
									setErrorIframe(true);
								}
							}}
							onChange={(e) => {
								try {
									setIframe(e.currentTarget.value);
									setErrorIframe(false);

									const url = new URL(e.currentTarget.value);
									const pathname = url.pathname;

									if (
										!(
											pathname.startsWith("/maps/@") ||
											pathname.startsWith("/maps/dir/") ||
											pathname.startsWith("/maps/search/") ||
											pathname.startsWith("/maps/place/")
										)
									) {
										throw Error("Invalid URL");
									}
								} catch (error) {
									console.error(error);
									// SHOW ERROR
									setErrorIframe(true);
								}
							}}
						/>
						<Box
							sx={{
								display: "flex",
								marginTop: 2,
								gap: 1,
								justifyContent: "end",
								flexDirection: { xs: "column", sm: "row" },
							}}
						>
							<Button
								onClick={handleModalCancel}
								sx={{
									fontSize: { xs: "0.875rem", sm: "1rem" },
								}}
							>
								Cancelar
							</Button>
							<Button
								variant="contained"
								onClick={handleModalSave}
								disabled={!iframe /* || errorIframe*/}
								sx={{
									backgroundColor: "#6366F1 !important",
									fontSize: { xs: "0.875rem", sm: "1rem" },
									"&:hover": {
										backgroundColor: "#6366F1 !important",
									},
								}}
							>
								Guardar
							</Button>
						</Box>
					</Box>
				}
				hideClose
			/>
		</>
	);
};

export default Map;
